import { render, staticRenderFns } from "./MyDynamicsView.vue?vue&type=template&id=bfe3670c&scoped=true"
import script from "./MyDynamicsView.vue?vue&type=script&lang=js"
export * from "./MyDynamicsView.vue?vue&type=script&lang=js"
import style0 from "./MyDynamicsView.vue?vue&type=style&index=0&id=bfe3670c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfe3670c",
  null
  
)

export default component.exports